// Which clock a displayed timestamp was measured on. Most of the app's timestamps are
// written by the app itself, but anything derived from the robot's execution logs carries
// the robot's own clock, which can sit minutes away from ours - so two timestamps are only
// comparable when they share a source. Rendered as the `title` of the element showing the
// timestamp, so the reader can tell which clock they are looking at.
export const TIME_SOURCE = {
  robot: 'Robot',
  app: 'App'
} as const

export type TimeSource = typeof TIME_SOURCE[keyof typeof TIME_SOURCE]

// A title belongs on a real value, not on the dash a missing timestamp renders as.
export const timeSourceTitle = (
  value: string | null | undefined,
  source: TimeSource
): TimeSource | undefined => (
  value ? source : undefined
)
